<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
      <mask
        id="rf-left-panel-close-mask"
        width="24"
        height="24"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
        style="mask-type: alpha"
      >
        <path fill="#d9d9d9" d="M0 0h24v24H0z" />
      </mask>
      <g mask="url(#rf-left-panel-close-mask)">
        <path
          fill="inherit"
          stroke="none"
          d="M15.6 15.2V8.8L12.4 12zM5.6 20q-.6 0-1.1-.5T4 18.4V5.6q0-.6.5-1.1T5.6 4h12.8q.6 0 1.1.5t.5 1.1v12.8q0 .6-.5 1.1t-1.1.5zM8 19V5H5.6q-.2 0-.4.2l-.2.4v12.8q0 .2.2.4l.4.2zm1 0h9.4q.2 0 .4-.2l.2-.4V5.6q0-.2-.2-.4l-.4-.2H9z"
        />
      </g>
    </svg>
  </span>
</template>
